module.exports = __webpack_public_path__ + "static/media/resource-2.d9bc3220.jpg";